import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Newspaper, Sparkles, ArrowRight, ExternalLink } from 'lucide-react';
import { useLanguage } from '@/contexts/LanguageContext';

export const AnnouncementBanners = () => {
  const { language } = useLanguage();
  const [tribuneVisible, setTribuneVisible] = useState(true);

  // Alternate text for the Village de la Justice banner
  const tribuneTexts = language === 'fr' ? [
    'Retrouvez-nous sur le Village de la Justice',
    'Tribune : L\'IA générative, alliée face à l\'inflation normative',
  ] : [
    'Read us on Village de la Justice',
    'Op-Ed: Generative AI, an ally against regulatory inflation',
  ];

  const [tribuneTextIndex, setTribuneTextIndex] = useState(0);
  const [isFading, setIsFading] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setIsFading(true);
      setTimeout(() => {
        setTribuneTextIndex(prev => (prev + 1) % tribuneTexts.length);
        setIsFading(false);
      }, 400);
    }, 4000);
    return () => clearInterval(interval);
  }, [tribuneTexts.length]);

  return (
    <section className="py-6 bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col sm:flex-row gap-4">
        {/* Village de la Justice Tribune banner */}
        <Link
          to="/articles/tribune-ia-generative-inflation-normative"
          className="flex-1 group flex items-center gap-4 rounded-xl border border-purple-200 bg-purple-50/50 px-6 py-4 hover:border-purple-400 hover:bg-purple-50 transition-all"
        >
          <div className="w-10 h-10 rounded-lg bg-purple-100 flex items-center justify-center flex-shrink-0">
            <ExternalLink className="w-5 h-5 text-purple-600" />
          </div>
          <div className="flex-1 min-w-0">
            <span className="text-xs font-semibold uppercase tracking-wider text-purple-700">
              Village de la Justice
            </span>
            <p className={`text-sm text-foreground font-medium truncate transition-opacity duration-400 ${isFading ? 'opacity-0' : 'opacity-100'}`}>
              {tribuneTexts[tribuneTextIndex]}
            </p>
          </div>
          <ArrowRight className="w-4 h-4 text-muted-foreground group-hover:text-purple-600 transition-colors flex-shrink-0" />
        </Link>

        {/* New training banner */}
        <Link
          to={language === 'fr' ? "/formations/eligibles/ia-securite-secret-professionnel" : "/training/eligible/ai-security-professional-secrecy"}
          className="flex-1 group flex items-center gap-4 rounded-xl border border-primary/20 bg-primary/5 px-6 py-4 hover:border-primary/40 hover:bg-primary/10 transition-all"
        >
          <div className="w-10 h-10 rounded-lg bg-primary/15 flex items-center justify-center flex-shrink-0">
            <Sparkles className="w-5 h-5 text-primary" />
          </div>
          <div className="flex-1 min-w-0">
            <span className="text-xs font-semibold uppercase tracking-wider text-primary">
              {language === 'fr' ? 'Nouvelle formation' : 'New Training'}
            </span>
            <p className="text-sm text-foreground font-medium truncate">
              {language === 'fr'
                ? 'Utiliser l\'IA en toute sécurité et protéger le secret professionnel'
                : 'Use AI securely and protect professional confidentiality'}
            </p>
          </div>
          <ArrowRight className="w-4 h-4 text-muted-foreground group-hover:text-primary transition-colors flex-shrink-0" />
        </Link>
      </div>
    </section>
  );
};
